<template>
  <section>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Franchisee Details</p>
          </div>
        </div>
        <router-link slot="right" :to="{ name: 'Franchisee' }" class="button is-small is-link">Back to list </router-link>
      </div>
    </section>
    <section class="container section page-header section is-main-section">
      <div>
        <card-component>
          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label">Franchisee Name</label>
                <div class="control">
                  <input class="input" type="text" v-model.trim="franchiseeObj.companyName" maxlength="100" disabled />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">B2B Code</label>
                <div class="control">
                  <input class="input" type="text" v-model.trim="franchiseeObj.b2bID" disabled />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Academic Year</label>
                <div>
                  <select class="input wrapper" v-model.trim="franchiseeObj.academicYearID" disabled>
                    <option value>---Select---</option>
                    <option v-for="yr in academicYrs" v-bind:key="yr.id" v-bind:value="yr.id"> {{ yr.academicYear }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns form-row">
            <div class="column is-6">
              <div class="field">
                <label class="label">Email address</label>
                <div class="control">
                  <input class="input" type="email" name="email" v-model="franchiseeObj.email" disabled />
                </div>
              </div>
            </div>

            <div class="column is-6" v-if="!franchiseeId">
              <div class="field">
                <label class="label">Password</label>
                <div class="control">
                  <input class="input" type="password" name="password" v-model="franchiseeObj.password" disabled />
                </div>
              </div>
            </div>
          </div>
          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label">Mobile number</label>
                <div class="control">
                  <input class="input" v-model.trim="franchiseeObj.mobileno" disabled />
                </div>
              </div>
            </div>

            <div class="column">
              <div class="field">
                <label class="label">Business Partner Contact No</label>
                <div class="control">
                  <input class="input" v-model.trim="franchiseeObj.businessPartnerMobileno" disabled />
                </div>
              </div>
            </div>

            <div class="column">
              <div class="field">
                <label class="label">GST Type</label>
                <div class="control">
                  <select class="input wrapper" v-model.trim="franchiseeObj.gstType" @change="getGSTtype()" disabled>
                    <option value>---select---</option>
                    <option v-for="gst in this.gstTypeArr" v-bind:key="gst.name" v-bind:value="gst.name">{{ gst.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column" v-if="this.enableGST">
              <div class="field">
                <label class="label">GST NO</label>
                <div class="control">
                  <input type="text" :readonly="checkreadonly" class="input" v-model="franchiseeObj.gstNo" value placeholder="Enter GST no" disabled />
                </div>
              </div>
            </div>
          </div>
          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label">Center Type</label>
                <div class="control">
                  <select class="input wrapper" v-model.trim="franchiseeObj.modelID" disabled>
                    <option value>---select---</option>
                    <option v-for="r in this.modelArr" v-bind:key="r.id" v-bind:value="r.id"> {{ r.title }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label">Franchisee Type</label>

                <select class="input wrapper" v-model.trim="franchiseeObj.type" disabled>
                  <option value>---Select---</option>
                  <option v-for="type in typeArr" v-bind:key="type.name" v-bind:value="type.name"> {{ type.name }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label">Tan No</label>
                <div class="control">
                  <div class="control">
                    <input class="input" type="number" v-model.trim="franchiseeObj.tanNo" />
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label">Account No</label>
                <div class="control">
                  <input class="input" type="text" v-model.trim="franchiseeObj.accountNumber" disabled />
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="columns form-row">
            <div class="column is-6">
              <div class="field">
                <label class="label">Address</label>
                <div class="control">
                  <textarea v-model.trim="franchiseeObj.address1" type="text" class="textarea is-small" disabled></textarea>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label">
                  Pincode
                  <span class="requir"></span>
                </label>
                <div class="control">
                  <input class="input" disabled type="tel" v-model.trim="franchiseeObj.pincode" />
                </div>
              </div>
            </div>
          </div>
          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label">
                  City
                  <span class="requir"></span>
                </label>
                <div class="control">
                  <input class="input" disabled type="text" v-model.trim="franchiseeObj.city" />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">
                  State
                  <span class="requir"></span>
                </label>
                <div class="control">
                  <input class="input" disabled type="text" v-model.trim="franchiseeObj.state" />
                </div>
              </div>
            </div>
          </div>
          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label">
                  Academic Year start Date
                  <span class="requir"></span>
                </label>
                <div class="control">

                  <custom-date-picker prepend-icon="mdi-calendar"  :disabled="true" v-model="franchiseeObj.academicStartDate" required />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">
                  Academic Year End Date
                  <span class="requir"></span>
                </label>
                <div class="control">
                  <custom-date-picker prepend-icon="mdi-calendar" :disabled="true" :minToDate="franchiseeObj.academicStartDate"
                  v-model="franchiseeObj.academicEndDate" required />
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label">First Name</label>
                <div class="control">
                  <input type="text" class="input" v-model="franchiseeObj.firstname" disabled />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Last Name</label>
                <div class="control">
                  <input class="input" type="text" v-model="franchiseeObj.lastname" disabled />
                </div>
              </div>
            </div>
          </div>
        </card-component>
      </div>
    </section>
  </section>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import CustomDatePicker from '@/components/template/CustomDatePickerr'
import moment from 'moment'

export default {
  name: 'ViewFranshisee',
  props: ['franchiseeId'],
  data () {
    return {
      startDate: moment().format('DD-MMM-YYYY'),
      endDate: moment().format('DD-MMM-YYYY'),
      franchiseeObj: {
        email: '',
        mobileno: '',
        address1: '',
        city: '',
        state: '',
        b2bID: '',
        firstname: '',
        lastname: '',
        companyName: '',
        gstNo: '',
        modelID: '',
        type: '',
        advisoryFeePercentage: '',
        tanNo: '',
        accountNumber: '',
        password: '',
        academicYearID: '',
        gstType: '',
        pincode: '',
        businessPartnerMobileno: ''
      },
      checkreadonly: false,
      enableGST: false,
      tempGSTno: '',
      stateArr: [],
      modelArr: [],
      typeArr: [{ name: 'FOFO' }, { name: 'COCO' }],
      gstTypeArr: [{ name: 'URD' }, { name: 'RD' }],
      hasClicked: false,
      loader: true,
      getTitle: 'Franchisee Details',
      error: null,

      academicYrs: []
    }
  },
  created () {
    if (this.franchiseeId) {
      this.getTitle = 'Franchisee Details'
      this.getFranchiseeDetails(this.franchiseeId)
    }

    this.getModelID()
    this.getAcademicYrs()
  },
  components: {
    CardComponent,
    CustomDatePicker
  },
  watch: {
    userName (newValue) {
      this.form.name = newValue
    },
    userEmail (newValue) {
      this.form.email = newValue
    }
  },
  methods: {
    getStateCityDetails: async function (pincode) {
      try {
        const response = await http.get(`${constants.API_URL}/api/city-by-pincode/${this.franchiseeObj.pincode}`)
        this.franchiseeObj.pincode = response.data.pincode
        this.franchiseeObj.state = response.data.state_name
        this.franchiseeObj.city = response.data.city
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching Franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true

        })
      }
    },
    getFranchiseeDetails: async function (franchiseeId) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(`${constants.API_URL}/api/franchisee/${franchiseeId}`)
        this.franchiseeObj = response.data
        this.franchiseeObj.gstType = this.franchiseeObj.gstNo === 'URD' ? 'URD' : 'RD'
        this.tempGSTno = this.franchiseeObj.gstNo
        this.enableGST = true
        if (this.franchiseeObj.gstNo !== 'URD') {
          this.checkreadonly = true
        }
        this.loadingComponent.close()
        return this.franchiseeObj
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching Franchisee', errorMessage)

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true

        })
      }
    },

    getModelID: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee/model`)
        this.modelArr = response.data.rows
        return this.modelArr
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching models', errorMessage)

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true

        })
      }
    },
    getAcademicYrs: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYrs = response.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching academic yrs', errorMessage)

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true

        })
      }
    },

    getGSTtype: function () {
      if (this.franchiseeObj.gstType === 'URD') {
        this.franchiseeObj.gstNo = 'URD'
        this.checkreadonly = true
        this.enableGST = true
      } else if (this.franchiseeObj.gstType === 'RD') {
        if (this.franchiseeId) {
          this.franchiseeObj.gstNo = this.tempGSTno === 'URD' ? '' : this.tempGSTno
        } else {
          this.franchiseeObj.gstNo = ''
        }
        this.checkreadonly = false
        this.enableGST = true
      } else {
        this.franchiseeObj.gstNo = ''
        this.checkreadonly = true
        this.enableGST = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
select {
  -moz-appearance: window;
  -webkit-appearance: none;
  background: #f5f5f5 url('/images/arrow_down.png') right center no-repeat;
  padding-right: 20px;
}
@-moz-document url-prefix() {
  .wrapper {
    background: #f5f5f5 url('/images/arrow_down.png') right center no-repeat;
    padding-right: 20px;
  }
}

.select {
  width: 100%;
}
</style>
